import type { UsernameVerificationCredentials } from "@/modules/auth/common/types";
import { useIdentifyUserByUsernameMutation } from "@/modules/auth/services";
import { setChallenge, setResetFields, setVerificationId, } from "@/modules/auth/state";
import { useAppDispatch, useAppSelector, useNotify } from "@/shared/hooks";

import { UsernameVerificationForm } from "./Form";

export const UsernameVerification = () => {
  const dispatch = useAppDispatch();
  const { showErrorAlertNotification } = useNotify();
  const [identifyUserWithUsername, { isLoading }] = useIdentifyUserByUsernameMutation();

  const verificationId = useAppSelector(
    (state) => state.auth.verificationId,
  );
  const onSubmit = (value: UsernameVerificationCredentials) => {
    dispatch(setResetFields(value));
    identifyUserWithUsername({
      id: verificationId,
      userName: value.username,
    })
      .unwrap()
      .then((res) => {
        const id = res?.id || "";
        dispatch(setVerificationId(id));
        dispatch(setChallenge(res.challenge));
      })
      .catch((err) => {
        showErrorAlertNotification(err);
      });
  };

  return (
    <div className="full-width">
      <UsernameVerificationForm
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </div>
  );
};
